
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hjISk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4323dcfcba139915$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $a4qPs = parcelRequire("a4qPs");
var $1mmZ5 = parcelRequire("1mmZ5");

var $fgF5F = parcelRequire("fgF5F");

var $95O7y = parcelRequire("95O7y");
const $4323dcfcba139915$var$styles = {
    drawerContent: "_19pkze3t"
};
const $4323dcfcba139915$var$DrawerContent = (props)=>{
    const { onClose: onClose, isAdmin: isAdmin, isOnboarding: isOnboarding, data: data, appEditions: appEditions, methods: methods, onScreenChange: onScreenChange, onPermissionsFetched: onPermissionsFetched, ProjectCreate: ProjectCreate } = props;
    const defaultSelectedTemplateKey = data.defaultSelectedTemplateKey !== undefined ? data.defaultSelectedTemplateKey : (0, $fgF5F.defaultProps).defaultSelectedTemplateKey;
    const isTemplatePickerOpenInitially = data.isTemplatePickerOpenInitially !== undefined ? data.isTemplatePickerOpenInitially : (0, $fgF5F.defaultProps).isTemplatePickerOpenInitially;
    const isImportProjectOpenInitially = data.isImportProjectOpenInitially !== undefined ? data.isImportProjectOpenInitially : (0, $fgF5F.defaultProps).isImportProjectOpenInitially;
    const selectedProjectType = data.selectedProjectType !== undefined ? data.selectedProjectType : (0, $fgF5F.defaultProps).selectedProjectType;
    let source = data.source !== undefined ? data.source : (0, $fgF5F.defaultProps).source;
    // https://softwareteams.atlassian.net/browse/RLSS-4346
    const [originSource] = (0, $95O7y.useQueryParam)('originSource');
    if (!source && originSource !== undefined) source = originSource;
    return /*#__PURE__*/ $eJOHy.createElement((0, $a4qPs.Drawer), {
        isOpen: data.isOpen,
        width: "full",
        onClose: onClose,
        autoFocusFirstElem: true
    }, /*#__PURE__*/ $eJOHy.createElement((0, $1mmZ5.DrawerContent), {
        xcss: $4323dcfcba139915$var$styles.drawerContent
    }, /*#__PURE__*/ $eJOHy.createElement(ProjectCreate, {
        // @ts-expect-error new project create has less props
        isAdmin: isAdmin,
        isOnboarding: isOnboarding,
        isJswOnboarding: false,
        isJiraCoreOnboarding: false,
        skipTemplateSelection: false,
        isNextGen: data.isNextGen,
        showExperienceSelection: data.showExperienceSelection,
        recommendedTemplate: data.recommendedTemplate,
        isConnectedProjectScenario: false,
        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
        isImportProjectOpenInitially: isImportProjectOpenInitially,
        selectedProjectType: selectedProjectType,
        appEditions: appEditions,
        onCancel: methods.close,
        onSuccess: methods.onSuccess,
        onScreenChange: onScreenChange,
        onPermissionsFetched: onPermissionsFetched,
        source: source,
        onDrawerClose: onClose,
        setOnCloseCallback: methods.setOnCloseCallback,
        onCreateStarted: methods.onCreateStarted,
        recommendationSessionId: data.recommendationSessionId
    })));
};
var $4323dcfcba139915$export$2e2bcd8739ae039 = $4323dcfcba139915$var$DrawerContent;

});


//# sourceMappingURL=async-project-create-drawer.a9c68851.js.map
